import { GIANT_IDS, type GiantId } from '../../../../domain/ids/ids';
import type { LandId } from './landPositions';
import { LAND_PLACEMENTS } from './landPositions';

/**
 * Land art id → domain giant id.
 * Vulcano land belongs to Willy; other land ids match giant ids.
 */
export const LAND_GIANT_IDS: Record<LandId, GiantId> = {
  sol: 'sol',
  mu: 'mu',
  serj: 'serj',
  mona: 'mona',
  duck: 'duck',
  yetti: 'yetti',
  roza: 'roza',
  svami: 'svami',
  vulcano: 'willy',
  factor: 'factor',
  drakochi: 'drakochi',
};

export function giantIdForLand(landId: LandId): GiantId {
  return LAND_GIANT_IDS[landId];
}

export function allLandsMapToGiants(): boolean {
  return LAND_PLACEMENTS.every((land) => GIANT_IDS.includes(LAND_GIANT_IDS[land.id]));
}

export function allGiantsHaveLands(): boolean {
  const covered = new Set(Object.values(LAND_GIANT_IDS));
  return GIANT_IDS.every((giantId) => covered.has(giantId));
}
